import { ProgressBar } from "../components/progressBar.jsx";
import images from "../images/images.js";

function CheckpointCardView({
  locId,
  data,
  isVisited,
  timeProgress,
  spaceProgress,
  totalProgress,
  onDiscover,
  infoSignal,
}) {


  return (
    <div
      className="profile-infoContent"
      onClick={() => onDiscover(locId)}
    >
      <>
        <div className="locationInfo-leftInfo">
          <div className="locationInfo-TextGp">
            <div className="locationInfo-id">{data.id}</div>
            <div className="locationInfo-title">{data.title}</div>
            <div className="locationInfo-description">
              {data.description}
            </div>
            {isVisited ? (
              <div className="locationInfo-progressInfo">
                <div className="locationInfo-totalCountContiner">
                  <div className="mapOverview-progress-totalCount">
                    {totalProgress}
                  </div>
                  <div className="locationInfo-id"> /8 quests</div>
                </div>
                <div className="locationInfo-progressBar">
                  <div className="locationInfo-id timeT">Time travel</div>
                  <ProgressBar progress={timeProgress} type="time" />
                </div>
                <div className="locationInfo-progressBar">
                  <div className="locationInfo-id spaceT">Space travel</div>
                  <ProgressBar progress={spaceProgress} type="space" />
                </div>
              </div>
            ) : (
               <>
    <button className="locationInfo-goBtn">Discover</button>
    {infoSignal && (
      <div className="locationInfo-signal">
        Let’s start with the quests!
      </div>
    )}
  </>
            )}
          </div>
        </div>

        <div className="mapOverview-rightImage">
          <img src={images[`picture_${locId}`]} alt={data.title} />
        </div>
      </>
    </div>
  );
}

export {CheckpointCardView}